import { es } from './es';
import { en } from './en';

export const locales = {
  es,
  en
};

export const defaultLocale = 'en';

export const getLocale = () => {
  return process.env.REACT_APP_LANGUAGE || defaultLocale;
};

export const getSupportedLocales = () => {
  return Object.keys(locales);
};